import React, { useState, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Button } from "@progress/kendo-react-buttons";
import { LinkOutlined, FileOutlined } from "@ant-design/icons";
import "./Training.scss";

const Training = observer(() => {
  const [copied, setCopied] = useState(false);

  // Load Wistia script for proper video controls
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://fast.wistia.com/assets/external/E-v1.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      const existingScript = document.querySelector('script[src="https://fast.wistia.com/assets/external/E-v1.js"]');
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, []);

  const trainingVideoUrl = "https://latitudedigital.wistia.com/medias/lp00808mir";
  const trainingManualUrl = "https://cdn.latitudewebservices.com/downloads/d4urs-2025/2025_Ford_D4URC_Microsite_Training_Deck_v4.pdf";
  const guideUrl = "/downloads/2026EventPlanningGuideV2.pdf";

  const handleCopyVideoLink = () => {
    navigator.clipboard.writeText(trainingVideoUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const handleDownloadManual = () => {
    window.open(trainingManualUrl, "_blank");
  };

  return (
    <div className="training-page main-content">
      <div className="training-container">
        <h1 className="training-title">Event Training</h1>
        <p className="training-description">
          This section contains a required how to video that teaches staff and volunteers how to use the dealer portal and how to check participants in and out of the event.
        </p>

        <div className="training-content">
          {/* Video Player Section */}
          <div className="training-section">
            <div className="video-player-container">
              <div className="wistia_responsive_padding">
                <div className="wistia_responsive_wrapper">
                  <iframe
                    src="https://fast.wistia.net/embed/iframe/lp00808mir?videoFoam=true&controlsVisibleOnLoad=true&playButton=true"
                    title="Training Video"
                    allow="autoplay; fullscreen"
                    allowTransparency={true}
                    frameBorder="0"
                    scrolling="no"
                    className="wistia_embed"
                    name="wistia_embed"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            </div>
            <div className="link-section link-section-1">
              <div className="link-label">
                <LinkOutlined className="link-icon" />
                <span>Training Video</span>
              </div>
              <Button
                className="copy-button"
                onClick={handleCopyVideoLink}
                primary={true}
              >
                {copied ? "Link Copied!" : "Click to Copy Training Link to Clipboard"}
              </Button>
            </div>
          </div>

          {/* PDF Preview Section */}
          <div className="training-section">
            <div className="guide-preview-container">
              <iframe
                src={guideUrl}
                className="guide-preview-pdf"
                title="Event Planning Guide Preview"
              />
            </div>
            <div className="link-section">
              <div className="link-label">
                <FileOutlined className="link-icon" />
                <span>Training Manual</span>
              </div>
              <Button
                className="download-button"
                onClick={handleDownloadManual}
                primary={true}
              >
                Link to Download Printable Manual
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default Training;

